import React from 'react';
import CtaBtn from './CtaBtn';

var Hero = (props) => (
        <div className="heroContainer container flexColumn">
            <h1 className="heroFont">Your Tech Tasks.<br/>Taken Care Of. No BS.<br/>Guaranteed.</h1>
            <h2 className="subTitleFont bold">Digital Presence + Processes Delivered</h2>
            <CtaBtn click={props.click} name="Let's Talk" classes="subTitleFont bold"/>
        </div>
)

export default Hero;


// WEBPACK FOOTER //
// ./src/components/Hero.js